import { render, staticRenderFns } from "./ContestVote.vue?vue&type=template&id=03835242&"
import script from "./ContestVote.vue?vue&type=script&lang=js&"
export * from "./ContestVote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports